// allow  max width and max height as config to this module

const validateFile = function(file) {
  if( !( /image/i ).test( file.type ) ) {
    return `File ${file.name} is not an image.`
  }

  // No need to validate file size since we will resize it anyway
  // var sizeInMB = (file.size / (1024*1024)).toFixed(2);
  // if (sizeInMB > 2) {
  //   return 'File must be smaller than 2MB';
  // }

  return;
}

const processImage = function(result, callback, width) {
  var max_width = width || 600;
  // blob stuff
  var blob = new Blob([result]); // create blob...
  window.URL = window.URL || window.webkitURL;
  var blobURL = window.URL.createObjectURL(blob); // and get it's URL

  // helper Image object
  var image = new Image();
  image.src = blobURL;
  //preview.appendChild(image); // preview commented out, I am using the canvas instead
  image.onload = function() {
    // have to wait till it's loaded
    callback(resizeMe(image, max_width));
  }
}

function resizeMe(img, max_width) {
  var canvas = document.createElement('canvas');

  var width = img.width;
  var height = img.height;

  // calculate the width and height, constraining the proportions
  if (width > max_width) {
    //height *= max_width / width;
    height = Math.round(height *= max_width / width);
    width = max_width;
  }

  // resize the canvas and draw the image data into it
  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);
  return canvas.toDataURL("image/jpeg",0.7); // get the data from canvas as 70% JPG (can be also PNG, etc.)
}

export { validateFile, processImage };
